import { ECourierStatus } from '@northladder/services';

import { cn } from '../../../lib';
import { Badge } from '../../../ui/badge-cn';

import { getDealCourierStatusBadgeOptions } from './config';
import { useDealCourierStatusTranslations } from './useDealCourierStatusTranslations';

interface IDealStatusBadgeProps {
  status: ECourierStatus;
}

/**
 * -----------------------------------------------------------------------------
 * DealStatusBadge component displays the deal courier status.
 */
export function DealStatusBadge({ status }: IDealStatusBadgeProps) {
  const { label } = useDealCourierStatusTranslations(status);

  const { className, Icon } = getDealCourierStatusBadgeOptions(status);

  return (
    <Badge
      className={cn(
        'flex items-center gap-1 !rounded-lg px-2 py-1.5 text-xs',
        className
      )}
    >
      <Icon className="!size-4 stroke-current stroke-[1.5]" />
      {label}
    </Badge>
  );
}
